import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import Header from 'src/components/Header';
import Layout from 'src/components/Layout';
import Button, { ButtonAppearance } from 'src/components/Button';
import Footer from 'src/components/Footer';
import { HeadingScope } from 'src/components/Heading';

interface AboutUsProps {
  data: any;
}

const AboutUs: FC<AboutUsProps> = ({ data }) => {
  const {
    body,
    frontmatter: { button, buttonUrl },
  } = data.content;

  return (
    <HeadingScope>
      <Header isWhite />
      <Layout layout="Inner-page">
        <MDXRenderer>{body}</MDXRenderer>
        <Button appearance={ButtonAppearance.CHARLIE} url={buttonUrl}>
          {button}
        </Button>
      </Layout>
      <Footer />
    </HeadingScope>
  );
};

export default AboutUs;

export const query = graphql`
  query AboutUs {
    content: mdx(slug: { eq: "about-us/" }) {
      body
      frontmatter {
        button
        buttonUrl
      }
    }
  }
`;
